import React from "react";
import PropTypes from "prop-types";
import { Button } from "primereact/button";
import agent from "../../../../agent";

const ensureDateString = (val) => {
  if (!val) return undefined;
  try {
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return undefined;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}.${mm}.${yyyy}`;
  } catch (e) {
    return undefined;
  }
};

// Extract filename from Content-Disposition header, supporting RFC 5987 filename*
const getFilenameFromContentDisposition = (cd, fallback = "report.xlsx") => {
  try {
    if (!cd || typeof cd !== "string") return fallback;
    let m = cd.match(/filename\*=(?:UTF-8'')?([^;\s]+)/i);
    if (m && m[1]) {
      const raw = m[1].trim().replace(/^\"|\"$/g, "");
      try { return decodeURIComponent(raw); } catch (_) { return raw; }
    }
    m = cd.match(/filename=\"?([^\";]+)\"?/i);
    if (m && m[1]) return m[1];
    return fallback;
  } catch (_) {
    return fallback;
  }
};

const AvrPtcActionBar = ({ filterParam }) => {
  const handleExport = async () => {
    try {
      const params = {
        q: filterParam?.q || undefined,
        startDate: ensureDateString(filterParam?.startDate) || undefined,
        endDate: ensureDateString(filterParam?.endDate) || undefined,
        avrNum: filterParam?.avrNum || undefined,
        statusId: filterParam?.statusId || undefined,
      };
      const res = await agent.Payments.getPtcAvrReportFile(params);
      const cd = (res && (res.header?.['content-disposition'] || res.headers?.['content-disposition'])) || "";
      const filename = getFilenameFromContentDisposition(cd, "avr_ptc_report.xlsx");
      const blob = res?.body instanceof Blob ? res.body : new Blob([res?.text || ""], { type: res?.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const msg = agent.handleError(err);
      alert(msg);
    }
  };

  return (
    <div className="p-d-flex p-jc-end p-mb-3">
      <Button label="Выгрузить отчет" icon="pi pi-download" onClick={handleExport} />
    </div>
  );
};

AvrPtcActionBar.propTypes = {
  filterParam: PropTypes.object,
};

export default AvrPtcActionBar;
